import React from "react"
import { Tag } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"

import { SEVERITY } from "./PreflightFindings"

// The banner above Review Bills while it is filtered to one pre-flight finding. Its own markup
// rather than antd's Alert: Alert's light-blue default is never restyled by the dark theme, and
// its `action` slot sits outside the card header, so .table-action-links spacing never applied.
export default function FindingBanner({ filter, position, total, onBack, onNext, onClear }) {
    if (!filter) return null

    // Pre-Flight's View All: every finding's bills at once, so there is no "Finding X of N".
    const all = filter.code === "all"
    const current = position && position.current
    const severity = current && SEVERITY[current.severity]
    const eyebrow = all
        ? "All pre-flight findings"
        : position
        ? `Finding ${position.index + 1} of ${position.total}`
        : "Pre-flight finding"
    const message = all
        ? `${typeof total === "number" ? total : "Every"} bill(s) behind at least one pre-flight finding.`
        : filter.message

    return (
        <div className="finding-banner" role="status">
            <InfoCircleOutlined className="finding-banner__icon" />

            <div className="finding-banner__body">
                <div className="finding-banner__eyebrow">
                    {eyebrow}
                    {severity && (
                        <Tag color={severity.color} className="finding-banner__tag">
                            {severity.label}
                        </Tag>
                    )}
                </div>
                <div className="finding-banner__message">{message}</div>
            </div>

            <div className="finding-banner__actions">
                <a href="javascript:;" onClick={onBack}>
                    Back to Pre-Flight
                </a>
                {position && position.next && (
                    <a href="javascript:;" onClick={onNext}>
                        Next finding →
                    </a>
                )}
                <a href="javascript:;" onClick={onClear} className="finding-banner__clear">
                    Clear
                </a>
            </div>
        </div>
    )
}
